interface WorldParametersProps {
  parameters: {
    magicLevel: number
    scienceLevel: number
    civilizationLevel: number
    dangerLevel: number
    mysteryLevel: number
    complexityLevel: number
    uniquenessLevel: number
    chaosLevel: number
  }
}

const PARAMETER_INFO = [
  { key: 'magicLevel', label: '魔法レベル', color: 'bg-purple-500' },
  { key: 'scienceLevel', label: '科学技術', color: 'bg-blue-500' },
  { key: 'civilizationLevel', label: '文明レベル', color: 'bg-green-500' },
  { key: 'dangerLevel', label: '危険度', color: 'bg-red-500' },
  { key: 'mysteryLevel', label: '神秘性', color: 'bg-indigo-500' },
  { key: 'complexityLevel', label: '複雑さ', color: 'bg-yellow-500' },
  { key: 'uniquenessLevel', label: '独自性', color: 'bg-pink-500' },
  { key: 'chaosLevel', label: '混沌度', color: 'bg-orange-500' },
]

export function WorldParameters({ parameters }: WorldParametersProps) {
  return (
    <div className="space-y-4">
      <div className="grid gap-3">
        {PARAMETER_INFO.map(({ key, label, color }) => {
          const value = parameters[key as keyof typeof parameters]
          return (
            <div key={key} className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">{label}</span>
                <span className="text-sm font-bold">{value}/10</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`${color} h-2 rounded-full transition-all`}
                  style={{ width: `${value * 10}%` }}
                />
              </div>
            </div>
          )
        })}
      </div>
      
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <h4 className="font-semibold mb-2">パラメータ解説</h4>
        <div className="text-sm space-y-2">
          {getParameterDescription(parameters)}
        </div>
      </div>
    </div>
  )
}

function getParameterDescription(parameters: WorldParametersProps['parameters']) {
  const descriptions = []
  
  if (parameters.magicLevel >= 7) {
    descriptions.push('この世界では魔法が日常的に存在し、社会の基盤となっています。')
  } else if (parameters.magicLevel <= 2) {
    descriptions.push('魔法はほとんど存在せず、現実的な法則が支配する世界です。')
  }
  
  if (parameters.scienceLevel >= 8) {
    descriptions.push('高度な科学技術が発達し、宇宙開発や AI が実現しています。')
  } else if (parameters.scienceLevel <= 3) {
    descriptions.push('科学技術は原始的で、自然の力に頼る生活が中心です。')
  }
  
  if (parameters.dangerLevel >= 7) {
    descriptions.push('生存が困難な危険に満ちた世界で、常に警戒が必要です。')
  } else if (parameters.dangerLevel <= 3) {
    descriptions.push('比較的安全で平和な世界で、日常生活に大きな脅威はありません。')
  }
  
  if (parameters.chaosLevel >= 7) {
    descriptions.push('予測不可能で混沌とした世界で、秩序よりも変化が支配的です。')
  } else if (parameters.chaosLevel <= 3) {
    descriptions.push('秩序だった世界で、法律や規則が社会を安定させています。')
  }
  
  return descriptions.map((desc, index) => (
    <p key={index}>• {desc}</p>
  ))
}